import  React , {useState , useEffect} from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export default function RowRadioButtonsGroup({
  labelName , 
  options ,
  selectedValue = { id: "Any", label: "Any", value: "Any" },
   handleChangeSelection = () => {},
    }) {


      const [value, setValue] = useState(selectedValue);
    
  const handleChange = (newValue) => {
    setValue(newValue);
    handleChangeSelection(newValue)
  };
  useEffect(() => {
    setValue(selectedValue);
  }, [selectedValue]);
  return (
    <FormControl>
      <FormLabel id="demo-row-radio-buttons-group-label"
        sx={{
            color: "#050D2E",
            fontSize: ".875rem",
            fontWeight: "bold",
            letterSpacing: "-0.5px",
            lineHeight: "16px",
            marginBottom: "5px",
            pb: 1,
            pt: 1,
          }}
      >
     {labelName}   
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={value}
        onChange={(event, newValue) => {
          handleChange(newValue);
        }}
      >
        {options.map((option) =>(

        <FormControlLabel key={option.value} value={option.value || ''} control={<Radio />} label={option.label} />
        ))}
        
      </RadioGroup>
    </FormControl>
  );
}